import React, { useContext, useRef } from "react";

export const AntGlobalContext = React.createContext(null);
export const AntSessionContext = React.createContext(null);
export const AntSidebarContext = React.createContext(null);

// export const AntSession = useContext(AntContext);

export function AntGlobal() {
  return useContext(AntGlobalContext);
}

export function AntSession() {
  return useContext(AntSessionContext);
}

export function AntSidebar() {
  return useContext(AntSidebarContext);
}